import { DatePipe } from '@angular/common';

export class SchedulerReqModel {
	public type: string;
	public startTime: string;
	public repeat: boolean;
	public tz: string;
	private datePipe: DatePipe;

	constructor() {
		this.datePipe = new DatePipe('en-US');
	}

	public clone(source: any): SchedulerReqModel {
		if (source.schedulerType) {
			this.type = source.delivery ? 'MULTI' : source.schedulerType;
		}
		if (source.startDate) {
			this.startTime = `${this.datePipe.transform(
				source.startDate,
				'yyyy-MM-dd'
			)} ${source.startTime}`;
		}
		if (source.delivery) {
			this.repeat = source.delivery.toUpperCase();
		}

		return this;
	}

	public convert(): any {
		return {
			type: this.type,
			startTime: this.startTime,
			repeat: this.repeat,
			tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
		};
	}
}
